import axiosInstance from '@/lib/axiosInstance';
import { ActivityGradingCriteria } from '@/model/ActivityGradingCriteria.model';

export const getActivityGradingCriteria = async () => {
  const { data } = await axiosInstance.get(`/activity-grading-criteria`);
  return ActivityGradingCriteria.fromJson(data);
};
